import gql from 'graphql-tag';

const query = gql`
  query resetPasswordSendEmail($email: String!) {
    resetPasswordSendEmail(email: $email) {
      code
      message
    }
  }
`;

export default query;
